// extracted by mini-css-extract-plugin
export default {"img":"socialLinks-module--img--TnSeI"};